import React from "react";

const CursorTextStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9992 12.9999V2.99995M11.9992 12.9999C11.9992 13.7999 10.1992 13.7999 10.1992 13.7999M11.9992 12.9999C11.9992 13.7999 13.7992 13.7999 13.7992 13.7999M11.9992 2.99995C11.9992 2.19995 10.1992 2.19995 10.1992 2.19995M11.9992 2.99995C11.9992 2.19995 13.7992 2.19995 13.7992 2.19995",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 8.19995H13",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.19922 11.4001L4.79922 4.6001L7.39922 11.4001",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.19922 9H6.39922",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CursorTextStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;